import { ModelApi } from '@/services/api/modelApi'
import { IStock } from '@/modules/inventory/stock/types/stockTypes'

/** Stock endpoint extends model api to inherit its methods and custom methods up to its needs */
export class StockEndpoints extends ModelApi<IStock> {
  constructor() {
    super('stock_and_price')
  }
}
